import React from "react";
import SEO from "../../../components/SEO";
import { Mail, Award } from "lucide-react";
import YashImg from "../../../assets/Yash.jpg";
import Testimonials from "../../../components/Testimonials";

const Ekta = () => {
  const facts = [
    {
      title: "Études",
      backText: "Yashraj a complété son diplôme en réseautage informatique et soutien technique au Collège Seneca. Durant cette période, il a développé une pensée logique solide, des aptitudes à la résolution de problèmes et la capacité de rester calme dans des situations complexes. Dans le domaine technologique, lorsque les systèmes tombent en panne, l'approche est méthodique : analyser, dépanner et résoudre étape par étape. Il applique cette même façon de penser à l'assurance, où la situation de chaque client est unique et nécessite un plan soigneusement adapté.",
    },
    {
      title: "Carrière",
      backText: "Yashraj a complété son diplôme en réseautage informatique et soutien technique au Collège Seneca. Durant cette période, il a développé une pensée logique solide, des aptitudes à la résolution de problèmes et la capacité de rester calme dans des situations complexes. Dans le domaine technologique, lorsque les systèmes tombent en panne, l'approche est méthodique : analyser, dépanner et résoudre étape par étape. Il applique cette même façon de penser à l'assurance, où la situation de chaque client est unique et nécessite un plan soigneusement adapté.",
    },
    {
      title: "Bénévolat",
      backText: "En dehors du travail, il apprécie les plaisirs simples de la vie, notamment regarder des films, essayer de nouveaux restaurants et explorer la ville. En tant que passionné de cinéma, il est toujours ouvert aux recommandations et discussions cinématographiques. Ses explorations urbaines mènent souvent à la découverte de nouvelles expériences culinaires en chemin.",
    },
    {
      title: "Loisirs",
      icon: <Award size={36} />,
      backText: "Le bénévolat communautaire a toujours été important pour lui. Il s'implique activement dans les initiatives de bénévolat de la Sant Nirankari Mission. À travers ce travail, il a participé à des collectes de nourriture, des camps de don de sang et des initiatives de propreté communautaire. Ces expériences ont renforcé sa conviction dans l'impact des actes de service simples et l'importance d'aider les autres comme partie intégrante de la vie.",
    },
  ];

  return (
    <>
      <SEO
        title="Yashraj Kharbanda — Courtier d'assurance agréé | einsured.ca"
        description="Découvrez Yashraj, courtier chez einsured.ca, qui accompagne les Canadiens avec des conseils d’experts et des solutions d’assurance personnalisées."
        keywords="Yashraj courtier d'assurance, conseiller en assurance Canada, meilleur courtier d'assurance, expert en assurance vie"
        ogType="profile"
      />
      <section className="min-h-screen flex flex-col justify-center items-center px-6 sm:px-12 md:px-24 py-16" style={{ backgroundColor: "#f5f9ff" }} >
      <style>{`
        .flip-card {
          background-color: transparent;
          perspective: 1000px;
        }
        .flip-card-inner {
          position: relative;
          width: 100%;
          height: 260px;
          text-align: center;
          transition: transform 0.8s;
          transform-style: preserve-3d;
          border-radius: 24px;
          box-shadow: 0 15px 25px rgba(0, 0, 0, 0.15);
        }
        .flip-card:hover .flip-card-inner {
          transform: rotateY(180deg);
        }
        .flip-card-front,
        .flip-card-back {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 24px;
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-family: "Inter", sans-serif;
          font-weight: 600;
        }
        .flip-card-front {
          background: linear-gradient(to bottom, #12a5dd, #3b4f80);
          color: white;
        }
        .flip-card-back {
          background: linear-gradient(to bottom, #3b4f80, #12a5dd);
          transform: rotateY(180deg);
          color: white;
          padding: 0 1.5rem;
        }

        /* Mobile polish for flip cards */
        @media (max-width: 640px) {
          .flip-card-inner {
            height: auto;
            min-height: 260px;
            transform: none !important;
          }
          .flip-card-front {
            display: none;
          }
          .flip-card-back {
            transform: none;
            padding: 1.25rem 1.25rem;
          }
        }
      `}</style>

      {/* TOP SECTION */}
      <div className="max-w-6xl w-full grid md:grid-cols-2 gap-12 items-start">
        {/* LEFT SIDE */}
        <div className="flex flex-col items-center md:items-start w-full">
          {/* Blue Box */}
          <div className="w-full rounded-t-[32px] px-8 py-6 text-center md:text-left shadow-md" style={{ backgroundColor: "#12a5dd", color: "white" }}>
            <h1 className="text-3xl sm:text-4xl font-bold mb-2">Yashraj</h1>
            <p className="text-lg font-semibold">Courtier d'assurance</p>
          </div>
          {/* Bottom Blue Box */}
          <div className="w-full rounded-b-[32px] px-8 py-8 shadow-lg" style={{ backgroundColor: "#12a5dd", color: "white" }}>
            <p className="text-sm sm:text-base leading-relaxed mb-6 text-center md:text-left">Le parcours de Yashraj dans l'assurance a commencé dans le monde de l'informatique. Il a travaillé comme analyste TI pendant plusieurs années, ce qui l'a entraîné à analyser soigneusement les problèmes, à comprendre le fonctionnement des systèmes et à développer des solutions pratiques. Aujourd'hui, il applique cette même façon de penser pour aider les clients à protéger ce qui compte le plus : leur famille, leur santé et leur avenir financier.</p><p className="text-sm sm:text-base leading-relaxed mb-10 text-center md:text-left">Pour lui, l'assurance va au-delà des polices et de la paperasse ; il s'agit de procurer la tranquillité d'esprit et de permettre aux clients de planifier leur vie avec plus de confiance. Il s'engage à garder tout simple, clair et transparent afin que les clients comprennent toujours exactement ce qu'ils obtiennent et pourquoi c'est important.</p>

            {/* CONTACT */}
            <div className="grid grid-cols-1 sm:grid-cols-[2fr_3fr] gap-x-4 gap-y-6">
              <a href="tel:+16476791829" className="bg-white text-[#3b5180] font-medium text-base px-3 py-3 rounded-full shadow-md text-center" >(647) 679-1829</a>
              <a href="mailto:kharbandayashraj1@gmail.com" className="bg-white text-[#3b5180] font-medium text-base px-3 py-3 rounded-full shadow-md flex items-center justify-center gap-2 break-all sm:break-normal"><Mail className="w-4 h-4" />kharbandayashraj1@gmail.com</a>
            </div>
          </div>

          {/* Call Now */}
          <div className="text-center md:text-left mt-10 md:mt-12 w-full">
            <a href="https://book.einsured.ca/widget/bookings/yashraj-kharbanda-einsured" className="bg-[#3b4f80] hover:bg-[#2f3d66] text-white font-semibold px-10 py-3 rounded-full shadow-md transition w-full sm:w-auto inline-block text-center">Prendre rendez-vous</a>
            <p className="text-sm mt-6">Consultations gratuites de 15 à 30 minutes.</p>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="flex justify-center md:justify-end mt-8 md:mt-0">
          <img src={YashImg} alt="Yashraj" className="rounded-[32px] shadow-md w-full max-w-xs sm:max-w-sm h-[420px] object-cover object-top" />
        </div>
      </div>

      {/* FACTS */}
      <div className="mt-24 max-w-6xl w-full">
        <div className="text-center mb-12 px-2">
          <h2 className="text-3xl sm:text-5xl font-bold text-[#49628b] mb-4">Quelques faits sur Yashraj</h2>
          <p className=" text-base sm:text-lg">Découvrez le profil de Yashraj pour mieux connaître ses domaines d'expertise et ses intérêts personnels.</p>
        </div>

        {/* Flip Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 max-w-5xl mx-auto">
          {facts.map((fact) => (
            <div key={fact.title} className="flip-card">
              <div className="flip-card-inner">
              {/* FRONT */}
                <div className="flip-card-front px-4">
                  {fact.icon && (
                    <div className="mb-3 flex justify-center">{fact.icon}</div>
                  )}
                  <h3 className="text-white text-2xl font-bold">{fact.title}</h3>
                </div>
                {/* BACK */}
                <div className="flip-card-back flex px-4">
                  <p className="text-white text-sm sm:text-base leading-relaxed font-normal">{fact.backText}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    {/* 4 EASY STEPS */}
    <section className="w-full flex justify-center bg-white py-16 sm:py-24 px-6 sm:px-12 md:px-24">
      <div className="max-w-6xl w-full grid md:grid-cols-2 gap-16 items-center">
        {/* LEFT SIDE TEXT */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <h2 className="text-3xl sm:text-5xl font-bold text-[#49628b] mb-5">4 étapes simples</h2>
          <p className="text-base sm:text-lg text-[#5f6f8f] mb-10 max-w-lg">Obtenez votre protection en quelques minutes et profitez d'une couverture d'assurance vie parfaitement adaptée à vos besoins.</p>
          <a href="tel:+16476791829" className="bg-[#3b4f80] hover:bg-[#2f3d66] text-white font-semibold px-12 py-3.5 rounded-full shadow-lg transition w-full sm:w-auto text-center">Appelez maintenant !</a>
          <p className="text-sm mt-4">Consultations gratuites de 15 à 30 minutes.</p>
        </div>
        {/* RIGHT SIDE */}
        <div className="bg-[#f5f8ff] rounded-[32px] shadow-lg px-6 sm:px-10 py-8 sm:py-10 md:px-14 md:py-12">
          <div className="relative pl-2 sm:pl-4">
            <div className="absolute left-6 sm:left-8 top-6 bottom-6 w-[2px] bg-[#3b4f80]/25"></div>
              {/* Step 1 */}
              <div className="flex items-start gap-4 sm:gap-6 mb-8 sm:mb-10 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">1</div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">Informations de base</h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed">Répondez à quelques questions de base pour nous aider à mieux vous connaître.</p>
                </div>
              </div>
              {/* Step 2 */}
              <div className="flex items-start gap-4 sm:gap-6 mb-8 sm:mb-10 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">2</div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">Analyse des besoins</h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed">Déterminez la couverture appropriée pour protéger vos proches.</p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-4 sm:gap-6 mb-8 sm:mb-10 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">3</div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">Questions de santé</h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed">Répondez à quelques questions liées à la santé pour obtenir un produit adapté à vos besoins.</p>
                </div>
              </div>
              {/* Step 4 */}
              <div className="flex items-start gap-4 sm:gap-6 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">4</div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">Obtenez votre devis gratuit !</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Ekta;
